import {
  Button,
  Flex,
  Form,
  FormInstance,
  Space,
  Typography,
  Upload,
  UploadFile,
} from 'antd'
import { Fragment, useEffect, useState } from 'react'
import { attachmentTypes, formatBytes } from '../../../models/Answer'
import { CloseOutlined, InboxOutlined, PlusOutlined } from '@ant-design/icons'
import i18n from '../../../i18n/setupLocalization'
import LocalizationKeys from '../../../i18n/LocalizationKeys'

const { Dragger } = Upload
const { Text } = Typography

interface Props {
  initialDisplayForm?: boolean
}

const AttachmentEditor = ({ initialDisplayForm = false }: Props) => {
  const [displayAttachmentForm, setDisplayAttachmentForm] =
    useState<boolean>(false)

  useEffect(() => {
    setDisplayAttachmentForm(initialDisplayForm)
  }, [initialDisplayForm])

  return (
    <Space direction="vertical" className="w-full">
      <Text>{i18n.t(LocalizationKeys.Misc.Form.Attachment)}</Text>
      {!displayAttachmentForm && (
        <Button
          block
          type="dashed"
          icon={<PlusOutlined />}
          onClick={() => {
            setDisplayAttachmentForm(true)
          }}
        >
          {i18n.t(LocalizationKeys.Misc.Form.AddAttachment)}
        </Button>
      )}
      {displayAttachmentForm && (
        <>
          <Flex gap={8} align="end" justify="flex-end">
            <Button
              danger
              type="dashed"
              icon={<CloseOutlined />}
              onClick={() => {
                setDisplayAttachmentForm(false)
              }}
            />
          </Flex>
          <Form.Item
            name="file"
            rules={[]}
            valuePropName="fileList"
            getValueFromEvent={(e: any) =>
              Array.isArray(e) ? e : e && e.fileList
            }
          >
            <Dragger
              maxCount={1}
              name={'file'}
              multiple={false}
              listType={'picture'}
              accept={attachmentTypes
                .map((e) => e.accept.join(','))
                .flat()
                .join(',')}
              beforeUpload={(file) => false}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                {i18n.t(LocalizationKeys.Misc.Form.FileClicOrDrag)}
              </p>
              <p>
                {i18n.t(LocalizationKeys.Misc.Form.FileCanBe)}
                <br />
                {attachmentTypes.map((type) => (
                  <Fragment key={type.id}>
                    {type.name} - {type.extensions.join(',')} - Max.{' '}
                    {formatBytes(type.maxSize)}
                    <br />
                  </Fragment>
                ))}
              </p>

              {/* <p className="ant-upload-hint">
                {i18n.t(LocalizationKeys.Misc.Form.FileMaxSize)}
              </p> */}
            </Dragger>
          </Form.Item>
        </>
      )}
    </Space>
  )
}

const validateFileList = (form: FormInstance, newFileList: UploadFile[]) => {
  form.setFieldValue('file', [])
  if (newFileList.length === 0) {
    return
  }

  // Considering only first file
  const newFile = newFileList[0]

  const firstPartMimeType = newFile.type?.split('/')[0]
  if (firstPartMimeType === undefined) {
    throw 'Unable to determine the uploaded file type from its metadata'
  }
  const attachmentType = attachmentTypes.find((a) =>
    a.accept.find((e) => e.startsWith(firstPartMimeType))
  )
  if (attachmentType === undefined) {
    throw 'File type is not accepted'
  }

  if (!newFile.size || newFile.size > attachmentType.maxSize) {
    throw i18n.t(LocalizationKeys.Misc.Form.FileSizeExceeds)
  }

  form.setFieldValue('file', [newFile])
}

export { validateFileList }
export default AttachmentEditor
